import { getFunctions, httpsCallable } from "firebase/functions";
import useSWR from "swr";
import { firebaseApp } from "../../../firebase/firebaseClient";
import {
  AveragePrepFqScores,
  IncomingAvgScores,
  PrepFqProfile,
  User,
} from "../../../models/users";
import { calculateAge } from "../../../utils/date";

const fetcher = async (
  url: string,
  scaled_score,
  date_of_birth,
  gender,
  question_id
) => {
  const functions = getFunctions(firebaseApp);
  const onGetAvgQuestionScores = httpsCallable(
    functions,
    "onGetAvgQuestionScores"
  );
  const avgScoresSnap = await onGetAvgQuestionScores({
    age: calculateAge(date_of_birth),
    gender: gender,
    scaled_score: scaled_score,
    private_key: process.env.NEXT_PREP_FQ_SCORING_KEY,
    question_id,
  } as IncomingAvgScores);
  return avgScoresSnap;
};

function useAveragePrepFqQuestionScores(
  profileId?: string,
  question_id?: string,
  user?: User,
  profile?: PrepFqProfile
) {
  const { data, mutate, error } = useSWR(
    [
      profileId && question_id && profile && user
        ? `/prepFq/${question_id}`
        : null,
      profile?.scored_results
        ?.slice()
        ?.find((scoredResult) => scoredResult.question_id === question_id)
        ?.scaled_score,
      user?.date_of_birth,
      user?.gender,
      question_id,
    ],
    fetcher
  );
  const result: {
    avgQuestionScores: AveragePrepFqScores;
    isLoading: boolean;
    isError: boolean;
    mutate: any;
  } = {
    avgQuestionScores: data?.data as any,
    isLoading: !error && !data?.data,
    isError: error,
    mutate,
  };
  return result;
}

export default useAveragePrepFqQuestionScores;
